import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from "react-icons/fa";
import "./DriverChecklistList.css";

const DriverList = () => {
  const [drivers, setDrivers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [statusFilter, setStatusFilter] = useState("Y");
  const navigate = useNavigate();

  useEffect(() => {
    fetchDrivers();
  }, []);

  const fetchDrivers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/drivers-list`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // handle wrapped response: { success: true, data: [...] }
      const driverData = response.data?.data || response.data || [];
      const drivers = Array.isArray(driverData) ? driverData : [];
      setDrivers(drivers);
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  const handleDelete = async (driverId) => {
    if (window.confirm("Are you sure you want to delete this driver?")) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(
          `${process.env.REACT_APP_BASE_API_URL}/drivers/${driverId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        fetchDrivers();
      } catch (error) {
        console.error("Error deleting driver:", error); 
      }
    }
  };

  const filteredDrivers = useMemo(() => {
    return drivers
      .filter((driver) =>
        statusFilter ? driver.is_active === statusFilter : true
      )
      .filter((driver) =>
        Object.values(driver)
          .join(" ")
          .toLowerCase()
          .includes(searchInput.toLowerCase())
      );
  }, [drivers, statusFilter, searchInput]);

  return (
    <div>
      <div
        className="main-page-button-container"
        style={{ display: "flex", alignItems: "center" }}
      >
        <button
          className="back-button"
          onClick={() => navigate("/main")}
          title="Back to Main Page"
        >
          <FaArrowLeft className="back-icon" />
        </button>

        <div style={{ flex: 1 }} />
        <div
          className="right-button"
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "flex-end",
            minWidth: 0,
          }}
        >
          <label htmlFor="statusSelect" className="status-filter-label">
            Filter By Status:
          </label>
          <select
            id="statusSelect"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="filter-inputchecklist"
          >
            <option value="Y">Active</option>
            <option value="N">Inactive</option>
            <option value="">All</option>
          </select>
        </div>
      </div>

      <div className="driver-checklist-list-container">
        <div className="driver-checklist-list-header">
          <button
            onClick={() => navigate("/add-driver")}
            className="create-new-checklist-button"
          >
            <FaPlus className="add-icon" /> Add New Driver
          </button>
          <div className="search-export-container">
            <input
              type="text"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="search-inputchecklist"
            />
          </div>
        </div>

        <div
          className="driverchecklisttable-container"
          style={{ height: "560px", overflow: "auto" }}
        >
          <table className="driver-checklist-list-table">
            <thead>
              <tr>
                <th>Driver Code</th>
                <th>Driver Name</th>
                <th>Status</th>
                <th style={{ textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredDrivers.map((driver) => (
                <tr key={driver.driver_id}>
                  <td>{driver.reporting_driver_code}</td>
                  <td>{driver.driver_name}</td>
                  <td>{driver.is_active === "Y" ? "Active" : "Inactive"}</td>
                  <td>
                    <div
                      className="breakdown-tracker-action-icons"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        justifyContent: "center",
                        minWidth: "70px",
                      }}
                    >
                      <FaEdit
                        className="action-icon edit-icon"
                        style={{
                          color: "#007bff",
                          fontSize: "1.1rem",
                          marginRight: 0,
                          cursor: "pointer",
                          verticalAlign: "middle",
                          transition: "color 0.2s, transform 0.2s",
                        }}
                        onClick={() =>
                          navigate(`/edit-driver/${driver.driver_id}`)
                        }
                        title="Edit"
                      />
                      <FaTrash
                        className="action-icon delete-icon"
                        style={{
                          color: "#dc3545",
                          fontSize: "1.1rem",
                          cursor: "pointer",
                          verticalAlign: "middle",
                          transition: "color 0.2s, transform 0.2s",
                        }}
                        onClick={() => handleDelete(driver.driver_id)}
                        title="Delete"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DriverList;
